import { forwardRef } from 'react'
import { Tr, Th } from 'app/common/ui-components/table'

import { Column } from './columns'
import { StatusHeader } from './cell'


type Props = {
  columns: Array<Column>
  titles: Record<Column, string>
  stuck: boolean
  shadow: boolean
  columnProps: Record<Column, {
    className?: string
    alignLeft?: boolean
    alignRight?: boolean
    alignCenter?: boolean
  }>
  onChangeSelectionAll: (selectedAll: boolean) => void
  selectedAll: boolean
  showSelectAllCheckbox: boolean
}

export const TableHeader = forwardRef<'tr', Props>(({
  columns,
  titles,
  stuck,
  shadow,
  columnProps,
  onChangeSelectionAll,
  selectedAll,
  showSelectAllCheckbox,
}: Props, ref) => {
  return (
    <Tr reference={ref} header>
      {columns.map((key, index) => (
        <Th
          key={key}
          bgFilled={stuck}
          borderShadowBottom={shadow}
          className={`index_${index}`}
          {...columnProps[key]}
        >
          {key === Column.Title
            ? <StatusHeader
              onClick={onChangeSelectionAll}
              checked={selectedAll}
              showSelectAllCheckbox={showSelectAllCheckbox}
            >
              {titles[key]}
            </StatusHeader>
            : titles[key]}
        </Th>
      ))}
    </Tr>
  )
})
